import { isMessageEvent, isSurveyEvent, isSurveyFeedbackQuestionEvent, isSurveyFeedbackResponseEvent, isSurveyInitializedEvent, isSurveyRatingResponseEvent, } from "../state/conversation/types";
import { isWebChatSmartResponseEvent, isWebChatSurveyEvent, } from '../state/conversation/webchat/types';
export const disableWebChatSmartResponseEvents = (events) => {
    const firstSmartResponseEventIndex = events.findIndex(isWebChatSmartResponseEvent);
    if (firstSmartResponseEventIndex === -1)
        return events;
    const firstSmartResponseEvent = events[firstSmartResponseEventIndex];
    const isThereMessageAfterSmartResponse = events.some(event => isMessageEvent(event) && event.createdAt > firstSmartResponseEvent.createdAt);
    return events.map(event => {
        return isThereMessageAfterSmartResponse && isWebChatSmartResponseEvent(event)
            ? Object.assign(Object.assign({}, event), { disabled: true }) : event;
    });
};
export const orderAndAggregateSurveyEvents = (events) => aggregateEvents([isSurveyEvent, isWebChatSurveyEvent], disableIgnoredSurveys(orderSurveyEvents(events)));
const disableIgnoredSurveys = (events) => {
    if (!events)
        return [];
    const response = [];
    const reversed = [...events].reverse();
    let i = 0;
    while (i < reversed.length) {
        const event = reversed[i];
        const next = reversed[i + 1];
        if (isSurveyInitializedEvent(event) && next && !isSurveyRatingResponseEvent(next)) {
            response.push(Object.assign(Object.assign({}, event), { disabled: true }));
        }
        else if (isSurveyFeedbackQuestionEvent(event) &&
            next &&
            !isSurveyFeedbackResponseEvent(next)) {
            response.push(Object.assign(Object.assign({}, event), { disabled: true }));
        }
        else {
            response.push(event);
        }
        i++;
    }
    return response.reverse();
};
export const aggregateEvents = (aggregationFunctions, events) => {
    if (!events)
        return [];
    const reversed = [...events].reverse();
    const aggregatedEvents = [];
    let i = 0;
    while (i < reversed.length) {
        const event = reversed[i];
        const applicableFunction = aggregationFunctions.find(func => func(event));
        if (!applicableFunction) {
            aggregatedEvents.push(event);
            i++;
            continue;
        }
        const previouslyAggregated = aggregatedEvents
            .slice(0, i)
            .findIndex(event => applicableFunction(event));
        if (previouslyAggregated >= 0 && !aggregatedEvents[previouslyAggregated].response) {
            aggregatedEvents[previouslyAggregated] = Object.assign(Object.assign({}, aggregatedEvents[previouslyAggregated]), event);
        }
        else {
            aggregatedEvents.push(event);
        }
        i++;
    }
    return aggregatedEvents.reverse();
};
const orderSurveyEvents = (events) => {
    if (!events)
        return [];
    const reversed = [...events].reverse();
    const orderedEvents = [];
    let i = 0;
    while (i < reversed.length) {
        const event = reversed[i];
        const isFeedbackQuestion = isSurveyFeedbackQuestionEvent(event);
        const next = reversed[i + 1];
        if (isFeedbackQuestion && next && isSurveyRatingResponseEvent(next)) {
            orderedEvents.push(next);
            orderedEvents.push(event);
            i += 2;
        }
        else {
            orderedEvents.push(event);
            i++;
        }
    }
    return orderedEvents.reverse();
};
//# sourceMappingURL=eventsUtils.js.map